var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 0.399902C4.69839 0.399902 0.400391 4.6979 0.400391 9.9999C0.400391 15.3019 4.69839 19.5999 10.0004 19.5999C15.3024 19.5999 19.6004 15.3019 19.6004 9.9999C19.6004 4.6979 15.3024 0.399902 10.0004 0.399902ZM7.65039 13.9789H5.70639V7.7229H7.65039V13.9789ZM6.66639 6.9549C6.05239 6.9549 5.65539 6.5199 5.65539 5.9819C5.65539 5.4329 6.06439 5.0109 6.69139 5.0109C7.31839 5.0109 7.70239 5.4329 7.71439 5.9819C7.71439 6.5199 7.31839 6.9549 6.66639 6.9549ZM14.7504 13.9789H12.8064V10.5119C12.8064 9.7049 12.5244 9.1569 11.8214 9.1569C11.2844 9.1569 10.9654 9.5279 10.8244 9.8849C10.7724 10.0119 10.7594 10.1919 10.7594 10.3709V13.9779H8.81439V9.7179C8.81439 8.9369 8.78939 8.2839 8.76339 7.7219H10.4524L10.5414 8.5909H10.5804C10.8364 8.1829 11.4634 7.5809 12.5124 7.5809C13.7914 7.5809 14.7504 8.4379 14.7504 10.2799V13.9789Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1e68b026.svg";
export { ForwardRef as ReactComponent };